import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialList: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M29.72 23.62h1.52v3.05h-1.52Zm0-9.15h1.52v3.05h-1.52Zm0-9.14h1.52v3.05h-1.52ZM11.43 26.67h18.29v1.52H11.43Zm0-9.15h18.29v1.53H11.43Zm0-9.14h18.29V9.9H11.43Zm0 13.71h18.29v1.53H11.43Zm0-9.14h18.29v1.52H11.43Zm0-9.14h18.29v1.52H11.43ZM9.91 23.62h1.52v3.05H9.91Zm0-9.15h1.52v3.05H9.91Zm0-9.14h1.52v3.05H9.91ZM.76 26.67h1.53v1.52h3.05v-1.52h1.52v-3.05H5.34v-1.53H2.29v1.53H.76zm0-9.15h1.53v1.53h3.05v-1.53h1.52v-3.05H5.34v-1.52H2.29v1.52H.76zM2.29 5.33H.76v3.05h1.53V9.9h3.05V8.38h1.52V5.33H5.34V3.81H2.29z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialList
